<template>
  <section class="page-container">
    <header class="header d-flex justify-content-start">
      <div class="header-logo">
        <img v-bind:src="currentBookImage" alt="Literature in abundance" class="header-image">
      </div>
      <div class="header-text">
        <h2>Short Fiction</h2>
        <h6>Stories for no reason</h6>
      </div>
    </header>
    <section class="d-flex justify-content-between col-12 main-content">
      <section class="description-content">
        <h4>The Last Dance</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1760650782/literature/The_Last_Dance_-_Borys_Turchyk_dkmlv8.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote style="font-style: italic">
          "I can’t see her face, my dancing partner - the hood of her cape covers her face, I only see the shape of a sharp chin. She’s tall, taller than me - and I’ve always been considered among the tallest guys in our town - and yet her cape’s hood conceals her face in such a way I can not see it. I know she’s beautiful, I have absolute certainty I could describe her beauty for hours on end, and yet I haven’t seen her face - just know it without doubt or hesitation. It feels like I don’t have to see her face right now either, not yet."
        </blockquote>

        <h4>Limboism</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1760650782/literature/Limboism_-_Borys_Turchyk_shjsej.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote>
          It’s a story about solitude, attachment, strange encounters, secret experiments, unexplained phenomena, survival - and, mostly, capybaras. It's a fictional tale that is set in an unidentified rural area and follows the unexpected adventure of Audrey and her two capybaras.
        </blockquote>

        <h4>Better Than Nothing</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1760650782/literature/Better_Than_Nothing_-_Borys_Turchyk_kz4qe9.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote>
          Why does the entertainment industry exist even after the world that was consuming it has ended? What had caused its demise? Who am I in this world and what purpose do I still have? This is the story about technology, complacency, end of the world, and hope.
        </blockquote>

        <h4>Give or Take</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1760650782/literature/Give_or_Take_-_Borys_Turchyk_tdcbij.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote>
          There's a barely explicable knowledge I possess, and a love interest of mine that has turned out to be a homophobic prick, to say the least. There are things that can be explained and things that can not. It's an odd story, whichever perspective you look at it from.
        </blockquote>

        <h4>Snowflake</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1760650782/literature/Snowflake_-_Borys_Turchyk_jigj2r.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote>
          It’s a short dark fairytale, inspired by the classical Brothers Grimm stories, and an attempt to mimic the narrative style of old tales. It’s a story of an old man and his granddaughter, of loss, deceit, and payback for the bad deeds. A nighttime story. Sleep tight!
        </blockquote>

        <h4>Daguerreotype</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1790948105/literature/Daguerreotype_-_Borys_Turchyk_eiqxmv.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote>
          Every deity knows their days are over as soon as they’re conjured. But to come to terms with finite immortality is the whole other thing entirely. To live without powers, to die multiple deaths, to see familiar faces fade away, that’s not something anyone should experience, deity or otherwise. But there is a way out… or is there?
        </blockquote>

        <h4>The Freedom Of Walls</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1790948088/literature/The_Freedom_Of_Walls_-_Borys_Turchyk_yolhyn.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote>
          What if one night, you would dream of something inconceivable? What if the next day, this would start becoming your reality? Would you discard it as a bad dream, or would you follow it into the rabbit hole?
        </blockquote>

        <h4>Promise</h4>
        <ul>
          <li><a href="https://res.cloudinary.com/dmhd8lsl2/raw/upload/v1790948099/literature/Promise_-_Borys_Turchyk_ehwf3l.epub">EPUB file</a> (free)</li>
        </ul>
        <blockquote>
          Even the most well planned life can be derailed by love. Or by death. Or by both? You never know…
        </blockquote>
      </section>
    </section>
    <ContactFooter/>
  </section>
</template>

<script>
import { useHead } from '@vueuse/head'
import ContactFooter from "@/routes/ContactFooter.vue";

const bookImages = [
    "https://res.cloudinary.com/dmhd8lsl2/image/upload/v1739390107/hydralien.net/books_2_g6jnla.jpg",
  "https://res.cloudinary.com/dmhd8lsl2/image/upload/v1739390107/hydralien.net/books_1_xcxlys.jpg"
];

const currentBookImage = bookImages[Math.floor(bookImages.length * Math.random())];

export default {
  name: "FictionPage",
  components: {ContactFooter},
  setup() {
    useHead({
      title: 'Short Fiction - Stories For No Reason',
      meta: [
        {
          name: 'description',
          content: "Collection of short fictional stories that I'm writing in my free time."
        },
      ],
      link: [
        { rel: 'icon', href: '/fiction/favicon.ico' }
      ]
    })
  },
  data: () => {
    return {
      currentBookImage
    }
  }
}
</script>

<style scoped src="./pageStyle.css"></style>
<style scoped>
</style>
